import {
    AfterViewChecked,
    ChangeDetectorRef,
    Component,
    ElementRef,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewChildren
} from '@angular/core';
import { Subscription } from 'rxjs';
import { PageService } from '../../../services/page.service';
import { CommunicationService } from '../../../services/communication.service';
import { ApplicationStateService } from '../../../services/application-state.service';
import { PageChangedEvent } from '../../../utils/events/page-changed-event';
import { PreloadService } from '../../../services/preload.service';
import { PositioningService } from '../../../services/positioning.service';
import { Position } from '../../../models/position';
import { PageComponent } from '../page/page.component';
import { Point, ZoomProperties, ZoomService } from '../../../services/zoom.service';
import { ZoomEvent } from '../../../utils/events/zoom-event';
import { ScrollPagesComponent } from '../scroll-pages/scroll-pages.component';
import { HomeworkService } from '../../../services/homework.service';
import { RectService } from '../../../services/rect.service';
import { EventUtils } from '../../../utils/event-utils';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Page } from '../../../models/page';
import { ModalService } from '../../../services/modal.service';
import { CookieService } from 'ngx-cookie-service';
import { WelcomeModalComponent } from './modal-container/welcome-modal/welcome-modal.component';
import { SidebarService } from '../../../services/sidebar.service';
import { environment } from '../../../../environments/environment';
import { sidebarConfig } from '../../../../environments/configs/sidebar-config';
import $ from 'jquery';
import _ from 'lodash';
import { ModalableAccessCode } from '../../../models/modalable-access-code';
import { NgStyle } from '@angular/common';
import { ModalContainerComponent } from './modal-container/modal-container.component';
import { FooterComponent } from '../../footer/footer/footer.component';
import { AccessibilityComponentDirective } from '../../../directives/accessibility-component.directive';

@Component({
    selector: 'app-pages',
    templateUrl: './pages.component.html',
    styleUrls: ['./pages.component.scss'],
    standalone: true,
    imports: [
        NgStyle,
        PageComponent,
        ScrollPagesComponent,
        ModalContainerComponent,
        FooterComponent,
        AccessibilityComponentDirective
    ]
})
export class PagesComponent implements OnInit, OnDestroy, AfterViewChecked {

    $container: JQuery;
    @ViewChildren(PageComponent) pages: Array<PageComponent>;
    @ViewChild(ScrollPagesComponent) scrollPagesComponent: ScrollPagesComponent;
    currentPages: Array<Page> = [];
    containerWidth: number;
    containerHeight: number;
    containerTranslateX: number;
    containerTranslateY: number;
    containerPadding: {
        top: number;
        right: number;
        bottom: number;
        left: number;
    };
    footerWidth: number;
    windowWidth: number;
    isIE: boolean;
    // Variables for ScrollMode component
    scrollContainer;
    currentScrollTopValue: number;
    prevScrollTopValue: number;
    prevContainerHeight: number;
    debouncedOnResize: (() => void) & _.Cancelable;
    debouncedOnScroll: (() => void) & _.Cancelable;
    isUserLoggedIn: boolean;
    singlePageWidth = 0;
    singlePageHeight = 0;
    env = environment;
    isDefaultMode = 1;
    scrollWrapperContainer;
    @ViewChild('container', { static: true }) private container: ElementRef;
    @ViewChild('pagesContainer', { static: true }) private pagesContainer: ElementRef;
    private $pagesContainer: JQuery;
    private lastTranslateX: number;
    private lastTranslateY: number;
    private maxTranslateX: number;
    private minTranslateX: number;
    private maxTranslateY: number;
    private minTranslateY: number;
    private subscriptionPageTurn: Subscription;
    private subscriptionViewModeChange: Subscription;
    private subscriptionPageSizeChange: Subscription;
    private subscriptionZoomLevelChange: Subscription;
    private subscriptionSidebarChange: Subscription;
    private isIOS: boolean;
    private footerContainer: JQuery;
    private headerContainer: JQuery;

    private init = false;

    /**
     * Constructor
     * @param {ApplicationStateService} applicationStateService
     * @param {PageService} pageService
     * @param {PositioningService} positioningService
     * @param {CommunicationService} communicationService
     * @param {PreloadService} preloadService
     * @param {RectService} rectService
     * @param {DeviceDetectorService} deviceService
     * @param {HomeworkService} homeworkService
     * @param sidebarService
     * @param changeDetectorRef
     * @param modalService
     * @param cookieService
     * @param {ZoomService} zoomService
     */
    constructor(public applicationStateService: ApplicationStateService,
                public pageService: PageService,
                public positioningService: PositioningService,
                private communicationService: CommunicationService,
                private preloadService: PreloadService,
                private rectService: RectService,
                private homeworkService: HomeworkService,
                private sidebarService: SidebarService,
                private deviceService: DeviceDetectorService,
                private changeDetectorRef: ChangeDetectorRef,
                private modalService: ModalService,
                private cookieService: CookieService,
                private zoomService: ZoomService) {

        this.debouncedOnResize = _.debounce(this.onResize, 100);
        this.debouncedOnScroll = _.debounce(this.onScroll, 10);
        this.currentPages = this.pageService.getCurrentPages();

        this.subscriptionPageTurn = this.communicationService.pageTurnConfirmed$.subscribe(() => {
            this.preloadService.preloadPages();
            this.currentPages = this.pageService.getCurrentPages();
        });

        this.subscriptionViewModeChange = this.communicationService.viewModeChangeAnnounced$.subscribe(() => {
            this.onViewModeChanged();
        });

        this.subscriptionPageSizeChange = this.communicationService.pageSizeChangedAnnounced$.subscribe(() => {
            this.resetContainer();
            this.updateFooter();
        });

        this.subscriptionSidebarChange = this.sidebarService.sidebarEventFired$.subscribe(event => {

            let ratio = 0;
            if (this.applicationStateService.isScrollMode()) {
                this.scrollPagesComponent.updateIndex = false;
                this.scrollPagesComponent.stopIndexAndFrameCalculation = true;
                this.scrollPagesComponent.calculateTotalContainerHeight();
                this.prevContainerHeight = this.scrollPagesComponent.totalContainerHeight;
                this.prevScrollTopValue = this.getScrollContainer().scrollTop();
                ratio = this.prevScrollTopValue / this.prevContainerHeight;
            }

            setTimeout(() => {
                this.resetContainer();
                this.updateFooter();
                if (this.applicationStateService.isScrollMode()) {
                    setTimeout(() => {
                        this.scrollPagesComponent.calculateTotalContainerHeight();
                        const currentContainerHeight = this.scrollPagesComponent.totalContainerHeight;
                        const newScrollTop = ratio * currentContainerHeight;
                        this.getScrollContainer().scrollTop(newScrollTop);
                        this.scrollPagesComponent.updateIndex = true;
                        this.scrollPagesComponent.stopIndexAndFrameCalculation = false;
                    }, 500);
                }

            }, sidebarConfig.sidebarTransitionSpeed);
        });

        this.subscriptionZoomLevelChange = this.communicationService.zoomLevelChangedAnnouncedSource$.subscribe((event: ZoomEvent) => {
            if (this.zoomService.isMinZoomed()) {
                this.resetZoom();
            } else {
                this.zoom(event.zoomLevel, event.mousePoint);
            }
        });
    }

    /**
     * Called after component creation.
     */
    ngOnInit(): void {
        this.setContainerPadding();
        this.isUserLoggedIn = this.applicationStateService.userData.loggedIn;
        this.isIOS = this.deviceService.getDeviceInfo().browser === 'safari' && this.deviceService.getDeviceInfo().device === 'iphone';
        this.isIE = this.deviceService.browser() === 'ie';

        this.$container = $(this.container.nativeElement);
        this.$pagesContainer = $(this.pagesContainer.nativeElement);
        this.preloadService.preloadPages();
        this.scrollContainer = undefined;
        this.scrollWrapperContainer = undefined;
        this.windowWidth = window.window.innerWidth;
        this.resetContainer();
        this.updateFooter();
        this.resetZoom();
        this.isDefaultMode = this.applicationStateService.currentViewMode.slug !== 'scroll' ? 1 : 0;
        if (this.applicationStateService.currentIndex > 0) {
            this.currentScrollTopValue = 11;
        }
        this.init = true;

        setTimeout(() => {
            const params = new URLSearchParams(window.location.search);
            const disableWelcomeScreen = params.has('disableWelcome');

            if ((!this.cookieService.check(WelcomeModalComponent.COOKIE_KEY) ||
                    this.cookieService.get(WelcomeModalComponent.COOKIE_KEY) === '1') && !disableWelcomeScreen &&
                !this.applicationStateService.isOfflineModeEnabled) {
                this.modalService.addAnimation(WelcomeModalComponent.MODAL_ID, 'bounceInDown');
                this.modalService.openWelcomeModal();
            }

            if (!this.applicationStateService.userData.accessCodeSelected) {
                this.modalService.openModal(new ModalableAccessCode());
            }
        }, sidebarConfig.sidebarTransitionSpeed);

    }

    /**
     * Called on component destruction.
     */
    ngOnDestroy(): void {
        this.subscriptionPageTurn.unsubscribe();
        this.subscriptionViewModeChange.unsubscribe();
        this.subscriptionPageSizeChange.unsubscribe();
        this.subscriptionZoomLevelChange.unsubscribe();
        this.subscriptionSidebarChange.unsubscribe();
    }

    ngAfterViewChecked(): void {

        if (!this.applicationStateService.isScrollMode()) {
            return;
        }

        const fixScrollTop = () => {
            if (!this.scrollContainer) {
                this.scrollContainer = $('#scrollablePagesContainer');
            }

            const ratio = this.prevScrollTopValue / this.prevContainerHeight;
            const currentScrollTopValue = currentContainerHeight * ratio;

            this.scrollContainer.scrollTop(currentScrollTopValue);
            this.prevContainerHeight = currentContainerHeight;
        };

        this.scrollPagesComponent.calculateTotalContainerHeight();
        const currentContainerHeight = this.scrollPagesComponent.totalContainerHeight;

        if (this.prevScrollTopValue && currentContainerHeight !== this.prevContainerHeight) {
            fixScrollTop();
        }
    }

    /**
     * Sets the footer width.
     */
    updateFooter(): void {
        this.footerWidth = this.containerWidth;
    }

    /**
     * Called on resize.
     * - Determine new view mode
     * - Set container padding
     * - Set container dimensions
     * - Sets footer width
     */
    onResize(): void {
        this.windowWidth = window.window.innerWidth;

        let ratio = 0;
        if (this.applicationStateService.isScrollMode()) {
            this.scrollPagesComponent.updateIndex = false;
            this.scrollPagesComponent.stopIndexAndFrameCalculation = true;
            this.scrollPagesComponent.calculateTotalContainerHeight();
            this.prevContainerHeight = this.scrollPagesComponent.totalContainerHeight;
            this.prevScrollTopValue = this.getScrollContainer().scrollTop();
            ratio = this.prevScrollTopValue / this.prevContainerHeight;
        }

        setTimeout(() => {
            this.resetContainer();
            this.updateFooter();

            if (this.applicationStateService.isScrollMode()) {
                setTimeout(() => {
                    // this.scrollPagesComponent.updatePageSizes();
                    this.scrollPagesComponent.calculateTotalContainerHeight();
                    const currentContainerHeight = this.scrollPagesComponent.totalContainerHeight;
                    const newScrollTop = ratio * currentContainerHeight;
                    this.getScrollContainer().scrollTop(newScrollTop);
                    this.scrollPagesComponent.updateIndex = true;
                    this.scrollPagesComponent.stopIndexAndFrameCalculation = false;
                    this.changeDetectorRef.detectChanges();
                }, 500);
            }

        }, sidebarConfig.sidebarTransitionSpeed);

        // this.resetContainer();
        // this.updateFooter();
    }

    /**
     *  Called when the "pan" starts (mobile).
     *  - Saves the current translate values.
     */
    onPanStart($event): void {

        const blacklistClasses = ['note'];

        // Prevent pan on Bookmark to not zoom in/out unintentional.
        // Happens here because HammerJs Events do not provide stopPropagation().
        for (const node of EventUtils.getEventPath($event.srcEvent)) {
            if (node.className && this.includesOneOf(node.className, blacklistClasses)) {
                return;
            }
        }

        if (!this.applicationStateService.isZoomed || this.applicationStateService.pageEditMode) {
            return;
        }

        // $event.preventDefault();
        this.lastTranslateX = this.containerTranslateX;
        this.lastTranslateY = this.containerTranslateY;
    }

    /**
     * Handler for "pan" event (mobile).
     * - Moves page around
     *
     * @param {Event} $event
     */
    onPan($event): void {

        if (this.applicationStateService.preventPanning) {
            return;
        }

        if (!this.applicationStateService.isZoomed ||
            this.applicationStateService.pageEditMode ||
            this.rectService.isElementInPointRect($event)) {
            return;
        }

        this.pan($event.deltaX, $event.deltaY);
    }

    /**
     * Handler for double tapping.
     * - Zoom to specific zoom step.
     *
     * @param {Event} $event
     */
    onDoubleTab($event): void {

        const whiteListClasses = ['bookviewer-page', 'upper-canvas'];
        if (!(EventUtils.getEventPath($event.srcEvent)[0].className &&
            this.includesOneOf(EventUtils.getEventPath($event.srcEvent)[0].className, whiteListClasses))) {
            return;
        }

        $event.preventDefault();

        if ($event.tapCount < 2) {
            return;
        }

        const mousePoint: Point = $event.center;
        const minZoomLevel: number = this.zoomService.getMinZoomLevel();
        const maxZoomLevel: number = this.zoomService.getMaxZoomLevel();
        const desiredZoomLevel: number = minZoomLevel + (maxZoomLevel - minZoomLevel) * 0.45;

        if (this.applicationStateService.zoomLevel >= desiredZoomLevel) {
            this.zoomService.zoomMaxOut(mousePoint);

            return;
        }

        this.zoomService.zoomToLevel(desiredZoomLevel, mousePoint);
    }

    /**
     * Get the container of this component.
     *
     * @returns {JQuery}
     */
    getContainer(): JQuery {
        return this.$container;
    }

    /**
     * Get the container of the pages.
     *
     * @returns {JQuery}
     */
    getPagesContainer(): JQuery {
        return this.$pagesContainer;
    }

    /**
     * is homework modal opened
     *
     * @returns {boolean}
     */
    isModalOpen(): boolean {
        return this.homeworkService.isHomeworkOpened();
    }

    onScroll(): void {
        if (this.getScrollContainer()) {
            this.currentScrollTopValue = this.scrollContainer.scrollTop();
        }
    }

    /**
     * Pan the pages by the given offset.
     *
     * @param {number} x
     * @param {number} y
     */
    private pan(x: number, y: number): void {
        const translateX: number = Math.max(Math.min(this.lastTranslateX + x, this.maxTranslateX), this.minTranslateX);
        let translateY = this.lastTranslateY;

        if (!this.applicationStateService.isScrollMode()) {
            translateY = Math.max(Math.min(this.lastTranslateY + y, this.maxTranslateY), this.minTranslateY);
        } else {
            translateY = 0;
        }

        this.setContainerTranslate(translateX, translateY);
    }

    /**
     * Reset the container.
     * - Determine new view mode
     * - Set container padding
     * - Set container dimensions
     * - Set container translate
     */
    private resetContainer(): void {
        this.positioningService.adjustViewMode(this.getContainer());
        this.setContainerPadding();
        this.setContainerDimensions();
        this.setContainerTranslate();
    }

    /**
     * Set the padding for the pages container.
     */
    private setContainerPadding(): void {

        if (this.applicationStateService.isScrollMode() && this.windowWidth > environment.mobileBreakPoint + 1) {
            this.containerPadding = {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            };

            return;
        }

        this.containerPadding = {
            top: 5,
            right: 0,
            bottom: 60,
            left: 0
        };
    }

    /**
     * Set the dimensions for the pages container.
     * (prevents jumping of footer)
     *
     * @param {number} w
     * @param {number} h
     */
    private setContainerDimensions(w?: number, h?: number): void {
        if (isNaN(w) || isNaN(h)) {
            const containerSize: Position = this.positioningService.getPagesContainerSize();
            w = containerSize.w * this.zoomService.getCurrentZoomLevel();
            h = containerSize.h * this.zoomService.getCurrentZoomLevel();
        }
        this.containerWidth = Math.floor(w);

        if (this.applicationStateService.isScrollMode() && this.applicationStateService.isZoomed) {
            this.containerWidth = this.containerWidth + 10;
        }

        if (!this.init) {
            this.changeDetectorRef.detectChanges();
        }

        this.containerHeight = Math.floor(h);
        if (this.applicationStateService.isScrollMode()) {
            const topbarHeight = this.getHeaderContainer().height();
            this.containerHeight = window.window.innerHeight - topbarHeight;

            if (this.windowWidth < environment.mobileBreakPoint) {
                const footerHeight = this.getFooterContainer().height();
                this.containerHeight = this.containerHeight - footerHeight - 25;
            }
        }

        this.setMinMaxTranslate();
        this.calculatePageImageDimension(this.pageService.getPageByIndex(0));
    }

    /**
     * Calculates the min/max translate of the page.
     */
    private setMinMaxTranslate(): void {
        const xMultiplier = 0.5;
        const yMultiplier = 0.5;

        this.minTranslateX = -(this.containerWidth * xMultiplier);
        this.maxTranslateX = (this.containerWidth * xMultiplier);

        this.minTranslateY = -(this.containerHeight * yMultiplier);
        this.maxTranslateY = (this.containerHeight * yMultiplier);
    }

    /**
     * Set the translation (position) of the pages.
     *
     * @param {number} x
     * @param {number} y
     */
    private setContainerTranslate(x?: number, y?: number): void {
        if (isNaN(x) || isNaN(y)) {
            x = 0;
            y = 0;
        }

        this.containerTranslateX = x;
        this.containerTranslateY = y;
        this.setIOSTranslate();
    }

    /**
     * Reset the zoom of the current page.
     */
    private resetZoom(): void {
        this.resetContainer();
        this.calculatePrevHeightAndScrollTop();
        this.communicationService.confirmZoom();
        this.updateFooter();
    }

    /**
     * Zoom the page to a specified level.
     * (optional: Specify the center point)
     *
     * @param {number} zoomLevel
     * @param {Point} mousePoint
     */
    private zoom(zoomLevel: number, mousePoint?: Point): void {
        this.calculatePrevHeightAndScrollTop();
        const zoomProperties: ZoomProperties = this.zoomService.scalePages(
            this,
            zoomLevel,
            mousePoint
        );

        this.setContainerDimensions(zoomProperties.scaledWidth, zoomProperties.scaledHeight);
        this.setContainerTranslate(zoomProperties.translateX, zoomProperties.translateY);
        this.calculatePageImageDimension(this.pageService.getPageByIndex(0));
        this.updateFooter();

        this.communicationService.confirmZoom();
    }

    private calculatePrevHeightAndScrollTop(): void {

        if (this.applicationStateService.isScrollMode()) {
            this.prevScrollTopValue = this.getScrollContainer().scrollTop();
            this.prevContainerHeight = this.scrollPagesComponent.totalContainerHeight;
        }
    }

    private setIOSTranslate(): void {
        if (this.isIOS) {
            $('.pages')
                .css('transform', `translate(${this.containerTranslateX}px,${this.containerTranslateY}px)`);
        }
    }

    private includesOneOf(value: string, searchStrings: Array<string>): boolean {

        for (const searchValue of searchStrings) {
            if (value && value.includes && value.includes(searchValue)) {
                return true;
            }
        }

        return false;
    }

    private onViewModeChanged(): void {
        this.scrollContainer = undefined;
        this.scrollWrapperContainer = undefined;
        const pageChangeEvent = new PageChangedEvent();
        pageChangeEvent.moveToPage = this.applicationStateService.currentIndex;
        this.communicationService.announcePageTurn(pageChangeEvent);
        this.resetContainer();
        if (this.applicationStateService.isScrollMode()) {
            this.isDefaultMode = 0;
            // When changing to ScrollMode the container size might not be correct on the first run of resetContainer.
            this.resetContainer();
            if (this.applicationStateService.currentIndex > 0) {
                // 11 because shadow is only shown if currentScrollTop value is above 10.
                this.currentScrollTopValue = 11;
            }
        } else {
            this.isDefaultMode = 1;
        }
        this.updateFooter();
    }

    private calculatePageImageDimension(page: Page): void {

        if (!this.applicationStateService.isScrollMode()) {
            const pagePosition: Position = this.positioningService.fitPage(
                page.image.width,
                page.image.height
            );

            const width = pagePosition.w * this.zoomService.getCurrentZoomLevel();
            const height = pagePosition.h * this.zoomService.getCurrentZoomLevel();

            this.singlePageWidth = Math.floor(width);
            this.singlePageHeight = Math.floor(height);
        } else {

            const pagePosition: Position = this.positioningService.fitPage(
                page.image.width,
                page.image.height
            );

            const shadowPadding = 10;
            const width = pagePosition.w * this.zoomService.getCurrentZoomLevel() - shadowPadding;
            let height = pagePosition.h * this.zoomService.getCurrentZoomLevel();
            const ratio = height / width;
            height = width * ratio;
            this.singlePageWidth = Math.floor(width);
            this.singlePageHeight = Math.floor(height);
        }
    }

    private getFooterContainer(): JQuery {
        if (!this.footerContainer) {
            this.footerContainer = $('.bookviewer-footer-container');
        }

        return this.footerContainer;
    }

    private getHeaderContainer(): JQuery {
        if (!this.headerContainer) {
            this.headerContainer = $('.bookviewer-topbar');
        }

        return this.headerContainer;
    }

    private getScrollContainer(): JQuery {
        if (!this.scrollContainer) {
            this.scrollContainer = $('#scrollablePagesContainer');
        }

        return this.scrollContainer;
    }
}
